exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\r\n.pageHeader {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.bg-grey {\r\n    background-color: #f6f6f6;\r\n}\r\n\r\n.logo {\r\n    font-size: 200px;\r\n}\r\n\r\n.quick-learn {\r\n    font-weight: bold;\r\n    margin-top: 4.7em;\r\n    text-align: right;\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n    .col-sm-4 {\r\n        text-align: center;\r\n        margin: 25px 0;\r\n    }\r\n\r\n    .quick-learn {\r\n        margin-top: 0;\r\n        text-align: center;\r\n    }\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./ClientApp/app/components/about/about.component.css
// module id = 345
// module chunks = 0